export default "__VITE_ASSET__1uuHIEdP__"